import { render, staticRenderFns } from "./talentsAdd.vue?vue&type=template&id=6567f799&scoped=true"
import script from "./talentsAdd.vue?vue&type=script&lang=js"
export * from "./talentsAdd.vue?vue&type=script&lang=js"
import style0 from "./talentsAdd.vue?vue&type=style&index=0&id=6567f799&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567f799",
  null
  
)

export default component.exports